import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient, Query } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';

import { ONE_DAY_MILLISECONDS, ONE_HOUR_MILLISECONDS } from '../../dateTime';
import { RhinoError } from '../../error';
import { QueryKey, queryPersistCachingMap } from '../queryKeys';

// persistence maxAge also affected, that's why it's so big
const DEFAULT_GC_TIME = 7 * ONE_DAY_MILLISECONDS;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      retry: (failureCount, error: Error | RhinoError) => {
        return failureCount === 0 && error instanceof RhinoError && error.code === 'EXPIRED_KS';
      },
      staleTime: 3 * ONE_HOUR_MILLISECONDS,
      gcTime: DEFAULT_GC_TIME,
      refetchOnWindowFocus: false,
    },
    mutations: {
      networkMode: 'always',
    },
  },
});

export function setRhinoStaleTime(staleTime: number) {
  const defaults = queryClient.getDefaultOptions();

  queryClient.setDefaultOptions({
    ...defaults,
    queries: {
      ...defaults.queries,
      staleTime,
    },
  });
}

function shouldDehydrateQuery(query: Query) {
  const queryKeyName = query.queryKey[0];
  const cachingFn = queryPersistCachingMap[queryKeyName as QueryKey];
  return typeof cachingFn === 'function' && cachingFn();
}

// TODO This method is not used yet. Consider the possibility of its use or removal in the future.
// @ts-expect-error TODO Fix
export const makePersistedQueryClient = (storage) => {
  const persister = createSyncStoragePersister({
    storage,
    //  @ts-expect-error TODO: add persistStorage as replacement of cacheStorage
    serialize: (data) => data,
    //  @ts-expect-error TODO: add persistStorage as replacement of cacheStorage
    deserialize: (serialized) => serialized,
  });

  persistQueryClient({
    queryClient,
    persister,
    dehydrateOptions: {
      shouldDehydrateQuery,
    },
  });
};
